export default __webpack_public_path__ + "static/media/message.ca90762e.svg";